// @ts-nocheck
import PostObject from "classes/Posts/PostObject";
import formatDate from "includes/formatDate";
import genRequest from "includes/request";

class AnimationObject {
	#animationId = null;
	#companyId = null;
	#title = null;
	#dateStart = null;
	#dateEnd = null;
	#lastChanged = null;
	#lastChangeAuthorId = null;
	#isAllDay = null;
	#recurenceRule = null;
	#color = null;
	#isDraft = null;
	#displayParticipation = null;
	#duplicateEventToNews = false;
	#post = null;
	#notify = true;
	#linkTo = [];
	#linkedTo = [];
	#linkedSites = [];
	#linkedGroups = [];
	#linkType = "sites";
	#isNew = true;
	#siteId = null;
	#author = false;

	#categories = [];

	constructor(props, force_notif) {
		if (props) {
			this.#animationId =
				typeof props?.id !== "undefined"
					? props.id
					: (typeof props?.animationId !== "undefined"
						? props.animationId
						: null);
			this.#companyId =
				typeof props?.companyId !== "undefined"
					? props.companyId
					: null;
			this.#title =
				typeof props?.title !== "undefined" ? props.title : null;
			this.#dateStart =
				typeof props?.startDate !== "undefined"
					? props.startDate
					: (typeof props?.dateStart !== "undefined"
						? props.dateStart
						: null);
			this.#dateEnd =
				typeof props?.endDate !== "undefined"
					? props.endDate
					: (typeof props?.dateEnd !== "undefined"
						? props.dateEnd
						: null);
			this.#lastChanged =
				typeof props?.lastChanged !== "undefined"
					? props.lastChanged
					: formatDate();
			this.#lastChangeAuthorId =
				typeof props?.lastChangeAuthorId !== "undefined"
					? props.lastChangeAuthorId
					: null;
			this.#isAllDay =
				typeof props?.isAllDay !== "undefined" ? props.isAllDay : false;
			this.#recurenceRule =
				typeof props?.recurenceRule !== "undefined"
					? props.recurenceRule
					: null;
			this.#color =
				typeof props?.color !== "undefined" ? props.color : null;
			this.#isDraft =
				typeof props?.isDraft !== "undefined" ? props.isDraft : false;
			this.#displayParticipation =
				typeof props?.displayParticipation !== "undefined"
					? props.displayParticipation
					: false;

			this.#notify =
				typeof props?.notify !== "undefined" ? props.notify : true;
			this.#linkTo = props?.linkTo;
			this.#linkType = props?.linkType || "sites";
			this.#linkedTo = props?.linkedTo || [];
			this.#linkedSites = props?.linkedSites || [];
			this.#linkedGroups = props?.linkedGroups || [];

			this.#author = props?.author;
			this.#categories = props?.categories?.length
				? props.categories
				: [];
			this.#post = props?.post;
		}

		if (!this.#animationId) this.#isNew = true;

		if (typeof force_notif !== "undefined") this.#notify = force_notif;
		else {
			if (props.notify) this.#notify = true;
			else this.#notify = this.#animationId ? false : true;
		}

		this.#post = this.#newPost(props.companyId || null, props?.author);
	}

	/** The event's own post (type 8), which carries its images. */
	#newPost(companyId, author) {
		return new PostObject({
			postTypeId: 8,
			notifyPost: false,
			isTargetPost: true,
			title: this.#title,
			publishedDate: this.#dateStart,
			priorityTo: this.#dateEnd,
			companyId,
			// Only the author's employee and site: spreading the account
			// would copy its `id` (the employee id) into the post id and
			// overwrite the post that happens to carry that id.
			employeeId: author?.employeeId ?? null,
			siteId: author?.siteId ?? null,
		});
	}

	fetchForEdit(cloned) {
		let prom = new Promise((resolve) => {
			let proms = [
				this.fetchLinkedGroups(),
				this.fetchLinkedSites(),
				this.fetchCategories(),
				// The author first: an event without a linked post gets a
				// new one on the author's site
				this.fetchAuthor().then(() => this.fetchLinkedPost()),
			];
			Promise.all(proms)
				.then(() => {
					return this.fetchImages(cloned);
				})
				.then(resolve);
		});
		return prom;
	}

	fetchForClone = () => this.fetchForEdit(true);

	fetchAuthor() {
		if (!this.#lastChangeAuthorId) return Promise.resolve(false);
		let req = genRequest("employees/" + this.#lastChangeAuthorId).then(
			(resp) => {
				// The API names the employee id `id`
				this.#author = resp ? { ...resp, employeeId: resp.id } : resp;
				return resp;
			}
		);
		return req;
	}

	fetchLinkedGroups() {
		if (!this.#animationId) return Promise.resolve(true);
		let req = genRequest(
			"animations/" + this.#animationId + "/groups"
		).then(
			(resp) => {
				this.#linkedGroups = resp?.length ? resp : [];
			},
			() => {
				this.#linkedGroups = [];
			}
		);
		return req;
	}

	fetchLinkedSites() {
		if (!this.#animationId) return Promise.resolve(true);
		let req = genRequest(
			"animations/" + this.#animationId + "/sites"
		).then(
			(resp) => {
				this.#linkedSites = resp?.length ? resp : [];
			},
			() => {
				this.#linkedSites = [];
			}
		);
		return req;
	}

	fetchLinkedPost() {
		if (!this.#animationId) return Promise.resolve(true);
		let req = genRequest("posts/animation/" + this.#animationId).then(
			(resp) => {
				// The API returns the list of the event's posts
				const linked = Array.isArray(resp) ? resp[0] : resp;
				this.#post = linked
					? new PostObject({
							title: this.#title,
							...linked,
							companyId: this.#companyId,
					  })
					: this.#newPost(this.#companyId, this.#author);
				return this.#post;
			},
			() => {
				this.#post = this.#newPost(this.#companyId, this.#author);
				return this.#post;
			}
		);
		return req;
	}

	fetchCategories() {
		let that = this;
		if (!this.#animationId) return Promise.resolve(true);
		let req = genRequest(
			"categories/animation/" + this.#animationId
		).then((resp) => {
			that.#categories = resp?.length ? resp : [];
			return that.#categories;
		});
		return req;
	}

	fetchImages(cloned) {
		let that = this;
		if (!this.#post) return Promise.resolve(true);
		let prom = new Promise((resolve) => {
			let inner = this.#post
				.fetchImages()
				.then(() => {
					return that.#post.fetchImagesFile(cloned);
				})
				.then(() => {
					resolve(that.images());
					return that.images();
				}, resolve);
			return inner;
		});
		return prom;
	}

	images(setImages) {
		if (!this.#post) return [];
		return this.#post.images(setImages);
	}

	categories(setCats) {
		if (typeof setCats !== "undefined") {
			this.#categories = setCats;
			if (this.#categories?.length)
				this.#color = this.#categories[0].categoryColor;
		}
		return this.#categories;
	}

	send() {
		let that = this;
		let prom = new Promise((resolve, reject) => {
			let xhr = that
				.sendAnim()
				.then(() => {
					return that.linkAnimation();
				}, reject)
				.then(() => {
					return that.sendPost();
				}, reject)
				.then(() => {
					resolve(true);
				}, reject);
			return xhr;
		});
		return prom;
	}

	async createNews() {
		let req = await genRequest(
			"posts",
			{
				title: this.title(),
				txt: this.txt(),
				postTypeId: 1,
				siteId: this.#siteId,
				draft: false,
				validationModeration: true,
				address: "",
				employeeId: this.#author.employeeId || this.#author.id,
				hasDuplicate: false,
				languageId: 1,
				isTargetPost: false,
				publishedDate: formatDate(),
			},
			"post"
		);
		if (this.images().length > 0) {
			const reqImages = this.images().map(({ documentFile }, idx) => {
				let file = documentFile;
				if (file?.indexOf("data:image") !== -1)
					file = file.split(",")[1];
				let data = {
					name: "eventImage" + idx + "_" + formatDate(),
					postId: req.postId || req.id,
					companyId: this.companyId(),
					siteId: req.siteId,
					fileDocString: file,
					docTypeId: 3,
				};
				return genRequest(
					"documents/from-base64",
					data,
					"post"
				).then((documentId) => {
					return genRequest(
						"posts/" + (req.postId || req.id) + "/documents",
						{
							documentId: documentId,
						},
						"post"
					);
				});
			});
			await Promise.all([reqImages]);
		}
		return req;
	}

	sendPost() {
		let post = this.#post;
		let that = this;
		let isNew = post.postId() ? false : true;

		let prom = new Promise((resolve, reject) => {
			let inner_prom = post
				.sendPost()
				.then(() => {
					if (!isNew) {
						resolve(true);
						return true;
					}
					const linkPostPromise = that.linkPost();
					if (this.#duplicateEventToNews) {
						return Promise.all([linkPostPromise, that.createNews()]);
					} else {
						return linkPostPromise;
					}
				}, reject)
				.then(() => {
					resolve(true);
				}, reject);
			return inner_prom;
		});
		return prom;
	}

	linkPost() {
		let req = genRequest(
			"animations/" + this.#animationId + "/posts",
			{
				animationId: this.#animationId,
				postId: this.#post.postId(),
			},
			"post"
		);
		return req;
	}

	notify() {
		let url = "AnimationNotifySitesExceptAuthor";
		let data = {};

		if (this.#linkType === "sites") {
			url = this.#isNew
				? "AnimationNotifySitesExceptAuthor"
				: "AnimationChangedNotifySitesExceptAuthor";
			data = {
				message: this.#title,
				listSiteId: this.#linkTo,
				author: this.#author,
				newsId: this.#post.postId(),
			};
		} else if (this.#linkTo) {
			url = this.#isNew
				? "AnimationNotifyGroup"
				: "AnimationChangedNotifyGroup";
			data = {
				message: this.#title,
				listGroupId: this.#linkTo,
				author: this.#author,
				newsId: this.#post.postId(),
			};
		}

		let req = genRequest("notifications/push/" + url, data, "post");
		return req;
	}

	sendAnim() {
		let that = this;

		let anim = this.values();

		if (!this.#animationId) delete anim.animationId;
		let prom = genRequest(
			"animations" + (this.#animationId ? "/" + this.#animationId : ""),
			anim,
			this.#animationId ? "put" : "post"
		).then((resp) => {
			if (!that.#animationId) that.#animationId = resp.id || resp.animationId;
		});
		return prom;
	}

	linkAnimation() {
		let that = this;
		let prom = new Promise((resolve, reject) => {
			Promise.all([
				that.unlinkSites(),
				that.unlinkGroups(),
				that.unlinkCategories(),
				that.#post.unlinkDocs(),
			])
				.then(() => {
					let proms = [];
					if (this.#linkType === "sites")
						proms.push(that.linkSites());
					else proms.push(that.linkGroups());
					proms.push(that.linkCategories());

					return Promise.all(proms);
				}, reject)
				.then(resolve, reject);
		});
		return prom;
	}

	linkGroups() {
		if (!this.#linkTo?.length) return Promise.resolve(true);
		let req = genRequest(
			"animations/" + this.#animationId + "/groups",
			{
				animationId: this.#animationId,
				groupToPost: this.#linkTo,
			},
			"post"
		);
		return req;
	}

	unlinkGroups = () =>
		genRequest(
			"animations/" + this.#animationId + "/groups",
			null,
			"delete"
		);

	linkSites() {
		if (!this.#linkTo?.length) return Promise.resolve(true);
		let req = genRequest(
			"animations/" + this.#animationId + "/sites",
			{
				animationId: this.#animationId,
				sitesToPost: this.#linkTo,
			},
			"post"
		);
		return req;
	}

	unlinkSites = () =>
		genRequest(
			"animations/" + this.#animationId + "/sites",
			null,
			"delete"
		);

	linkCategories() {
		let categories = this.#categories;

		if (!categories?.length) return Promise.resolve(true);

		let prom = genRequest(
			"animations/" + this.#animationId + "/categories",
			{
				animationId: this.#animationId,
				categoriesToPost: categories.map((a) => a.id || a.categoryId),
			},
			"post"
		);
		return prom;
	}

	unlinkCategories = () =>
		genRequest(
			"animations/" + this.#animationId + "/categories",
			null,
			"delete"
		);

	linkedPost = () => this.#post;

	animationId(setAnimationId) {
		if (typeof setAnimationId !== "undefined")
			this.#animationId = setAnimationId;
		return this.#animationId;
	}

	companyId(setCompanyId) {
		if (typeof setCompanyId !== "undefined") this.#companyId = setCompanyId;
		return this.#companyId;
	}

	title(setTitle) {
		if (typeof setTitle !== "undefined") this.#title = setTitle;
		return this.#title;
	}

	txt(setTxt) {
		if (typeof setTxt !== "undefined") this.#post.txt(setTxt);
		return this.#post.txt();
	}

	dateStart(setDateStart) {
		if (typeof setDateStart !== "undefined") {
			this.#dateStart = setDateStart;
			this.#post.publishedDate(setDateStart);
		}
		return this.#dateStart;
	}

	dateEnd(setDateEnd) {
		if (typeof setDateEnd !== "undefined") {
			this.#dateEnd = setDateEnd;
			this.#post.priorityTo(setDateEnd);
		}
		return this.#dateEnd;
	}

	lastChanged(setLastChanged) {
		if (typeof setLastChanged !== "undefined")
			this.#lastChanged = setLastChanged;
		return this.#lastChanged;
	}

	lastChangeAuthorId(setLastChangeAuthorId) {
		if (typeof setLastChangeAuthorId !== "undefined")
			this.#lastChangeAuthorId = setLastChangeAuthorId;
		return this.#lastChangeAuthorId;
	}

	isAllDay(setIsAllDay) {
		if (typeof setIsAllDay !== "undefined") this.#isAllDay = setIsAllDay;
		return this.#isAllDay;
	}

	recurenceRule(setRecurenceRule) {
		if (typeof setRecurenceRule !== "undefined")
			this.#recurenceRule = setRecurenceRule;
		return this.#recurenceRule;
	}

	color(setColor) {
		if (typeof setColor !== "undefined") this.#color = setColor;
		return this.#color;
	}

	isDraft(setIsDraft) {
		if (typeof setIsDraft !== "undefined") this.#isDraft = setIsDraft;
		return this.#isDraft;
	}

	notification(setNotif) {
		if (typeof setNotif !== "undefined") {
			this.#notify = setNotif;
			this.#post.notification(false);
		}
		return this.#notify;
	}

	participation(setParticipation) {
		if (typeof setParticipation !== "undefined") {
			this.#displayParticipation = setParticipation;
		}
		return this.#displayParticipation;
	}

	duplicateNews(setDuplicateNews) {
		if (typeof setDuplicateNews !== "undefined") {
			this.#duplicateEventToNews = setDuplicateNews;
		}
		return this.#duplicateEventToNews;
	}

	siteId(setSiteId) {
		if (typeof setSiteId !== "undefined") {
			this.#siteId = setSiteId;
		}
		return this.#siteId;
	}

	linkType(set_type) {
		if (set_type && set_type !== this.#linkType) {
			this.#linkType = set_type;
			this.#post.linkType(set_type);
		}
		return this.#linkType;
	}

	setLinkTo(items_list, link_type) {
		if (link_type) this.linkType(link_type);
		this.#linkTo = items_list;
		return this.#linkTo;
	}

	links() {
		if (this.#linkedSites?.length)
			return {
				type: "sites",
				links: this.#linkedSites.map((a) => a.siteId || a.id),
			};
		if (this.#linkedGroups?.length)
			return {
				type: "groups",
				links: this.#linkedGroups.map((a) => a.groupId || a.id),
			};
		return { type: "sites", links: [] };
	}

	linkedSites = () => this.#linkedSites;

	linkedGroups = () => this.#linkedGroups;

	getLinksTo() {
		if (!(this.#linkType && this.#linkTo)) return false;
		return {
			type: this.#linkType,
			links: this.#linkTo,
		};
	}

	values() {
		let ret = {
			animationId: this.#animationId,
			companyId: this.#companyId,
			title: this.#title,
			startDate: this.#dateStart,
			endDate: this.#dateEnd,
			lastChanged: this.#lastChanged,
			lastChangeAuthorId: this.#lastChangeAuthorId,
			isAllDay: this.#isAllDay,
			recurenceRule: this.#recurenceRule,
			color: this.#color,
			isDraft: this.#isDraft,
			displayParticipation: this.#displayParticipation,
			notify: this.#notify,
			linkTo: this.#linkTo,
			linkType: this.#linkType,
			linkedTo: this.#linkedTo,
		};
		return ret;
	}
}

export default AnimationObject;
